import actionTypes from './actionTypes';

export const fetch = (itineraryId) => ({
  type: actionTypes.FETCH,
  payload: {
    itineraryId,
  },
});

export const fetched = (data) => ({
  type: actionTypes.FETCHED,
  payload: {
    data,
  },
});

export const markAsCollected = (itineraryId) => ({
  type: actionTypes.MARK_AS_COLLECTED,
  payload: {
    itineraryId,
  },
});

export const markedAsCollected = (itineraryId) => ({
  type: actionTypes.MARKED_AS_COLLECTED,
  payload: {
    itineraryId,
  },
});

export const markAsReceived = (itineraryId, shipmentIds) => ({
  type: actionTypes.MARK_AS_RECEIVED,
  payload: {
    itineraryId,
    shipmentIds,
  },
});

export const markedAsReceived = (shipmentIds) => ({
  type: actionTypes.MARKED_AS_RECEIVED,
  payload: {
    shipmentIds,
  },
});

export const confirmCashCollected = (itineraryId, confirmedCash) => ({
  type: actionTypes.CONFIRM_CASH_COLLECTED,
  payload: {
    itineraryId,
    confirmedCash,
  },
});

export const confirmedCashCollected = (itineraryId) => ({
  type: actionTypes.CONFIRMED_CASH_COLLECTED,
  payload: {
    itineraryId,
  },
});

export const attachToItinerary = (itineraryId, shipmentIds) => ({
  type: actionTypes.ATTACH_TO_ITINERARY,
  payload: {
    itineraryId,
    shipmentIds,
  },
});

export const shipmentAttached = () => ({
  type: actionTypes.SHIPMENT_ATTACHED,
  payload: {},
});

export const deattachFromItinerary = (itineraryId, shipmentId) => ({
  type: actionTypes.DEATTACH_FROM_ITINERARY,
  payload: {
    itineraryId,
    shipmentId,
  },
});

export const shipmentDeattached = () => ({
  type: actionTypes.SHIPMENT_DEATTACHED,
  payload: {},
});

export const rearrangeShipments = (itineraryId, from, to) => ({
  type: actionTypes.REARRANGE_SHIPMENTS,
  payload: {
    itineraryId,
    from,
    to,
  },
});

export const shipmentRearranged = () => ({
  type: actionTypes.REARRANGE_DONE,
  payload: {},
});

export const updateRecipient = (values) => ({
  type: actionTypes.UPDATE_RECIPIENT,
  payload: {
    values,
  },
});

export const updatedRecipient = () => ({
  type: actionTypes.UPDATED_RECIPIENT,
  payload: {},
});

export const toggleRecipientScreen = () => ({
  type: actionTypes.TOGGLE_UPDATE_RECIPIENT_SCREEN,
  payload: {},
});
